<template>
  <transition name="el-zoom-in-center">
    <el-card v-show="add.addshow" class="box-card" style="text-align: left;">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>新增包装关系</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="add.addshow=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form ref="form" :model="add.form" label-width="110px" :rules="rules">
        <el-row>
          <el-col :span="18" :offset="6">
            <el-form-item label="包装级别" prop="package_level">
              <el-select v-model="add.form.package_level"  type="text" style="width:200px">
                <el-option
                  v-for="item in package_levellist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="包装单位" prop="package_unit_code">
              <el-select
                v-model="add.form.package_unit_code"
                type="text"
                style="width:200px"
                @change="getpackageunitname($event)"
              >
                <el-option
                  v-for="item in unitpagelist"
                  :key="item.product_unit_code"
                  :label="item.product_unit_cn"
                  :value="item.product_unit_code"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <br>
        <div style="text-align: center;">
          <!-- <el-button style="margin-top: 12px;" @click="resetForm('form')">重置</el-button> -->
          <el-button style="margin-top: 12px;" type="primary" @click="submitadd('form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
import { productunitpagelist } from '@/api/base'
import PanThumb from '@/components/PanThumb'
import { productlist } from '@/api/base'
import { workorderpackadd } from '@/api/plant'
export default {
  components: { PanThumb },
  props: {
    search: {
      type: Function,
      default: null
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: null,
          form: {
            workorder_senior_id: null,
            package_level: null,
            package_unit_cn: null,
            package_unit_code: null
            // status: 0,
            // sort: 0
          }
        }
      }
    }
  },
  data() {
    return {
      // 基础数据
      show: true,
      productloading: false,
      productlist: [],
      unitpagelist: [],
      storetypelist: [
        {
          value: 2,
          label: '公司仓库'
        },
        {
          value: 3,
          label: '经销商仓库'
        }
      ],
      package_levellist: [
        {
          value: 1,
          label: '一级包装'
        },
        {
          value: 2,
          label: '二级包装'
        },
        {
          value: 3,
          label: '三级包装'
        },
         {
          value: 4,
          label: '四级包装'
        },
        {
          value: 5,
          label: '五级包装'
        },
      ],
      rules: {
        package_unit_cn: [
          { required: true, message: '请选择包装单位', trigger: 'blur' }
        ],
        package_level: [
          { required: true, message: '请选择包装级别', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    productunitpagelist({ status: 0, pageindex: 1, pagesize: 100 }).then(
      response => {
        // 获取包装单位下拉
        console.log(response.data)
        this.unitpagelist = response.data.data
      }
    )
  },
  methods: {
    // 获取包装单位名称
    getpackageunitname(e) {
      console.log(e)
      let obj = {}
      obj = this.unitpagelist.find(item => {
        return item.product_unit_code === e // 筛选出匹配数据
      })
      this.add.form.package_unit_cn = obj.product_unit_cn
    },
    // 保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        // 基础表单验证
        if (valid) {
          workorderpackadd(this.add.form).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: 'success',
                message: '添加成功!'
              })
              this.search()
              this.add.addshow = false
              this.resetForm(this.form)
            } else {
              this.$message({
                type: 'warning',
                message: '添加失败!请检查字段'
              })
            }
          })
        } else {
          return false
        }
      })
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
